import React from 'react';

const ArtistOverlay = ({ artist, onClose }) => {
  if (!artist) return null;

  return (
    <div className={`artist-overlay ${artist ? 'open' : ''}`}
    onClick={onClose} // Ein Klick irgendwohin schließt das Overlay
    style={{ cursor: 'pointer' }}
    >
      
      {/* Hero Bereich */}
      <div style={{ height: '50vh', position: 'relative' }}>
        <img 
          src={artist.avatar} 
          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
          alt={artist.name} 
        />
        <div style={{ 
          position: 'absolute', bottom: 0, left: 0, width: '100%', 
          padding: '40px 20px', background: 'linear-gradient(to top, #000, transparent)' 
        }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '900', margin: 0 }}>{artist.name}</h1>
        </div>
      </div>

      {/* Content Bereich */}
      <div style={{ padding: '40px 20px', color: '#ccc' }}>
        <p style={{ 
          fontSize: '1.2rem', 
          lineHeight: '1.6', 
          fontStyle: 'italic',
          color: '#00acc1',
          marginBottom: '30px'
        }}>
          "{artist.vision || "No statement yet."}"
        </p>
        
        {/* Hier könnten später Social Links oder Top-Tracks hin */}
        <div style={{ height: '2px', background: '#222', margin: '20px 0' }} />
        <p style={{ fontSize: '0.8rem', letterSpacing: '2px' }}>COLLECTIVE ARTIST PROFILE</p>
      </div>
    </div>
  );
};

export default ArtistOverlay;